/**
 * @description 递归处理图片文件整合成一个对象 业务代码中引入
 */
const images = import.meta.glob('./**/*.*', { eager: true })
const imagesObj = { ...images }
const iconMap = {}
Object.keys(imagesObj).forEach((k) => {
  const name = k.split('/').slice(-1)[0].split('.')[0]
  iconMap[name] = imagesObj[k].default
})
export default iconMap
